
import { fetchGetSpaceReferences, fetchAddReference, fetchDeleteReference } from '../../helpers/api'; // adjust path if needed


export const FETCH_REFERENCES_REQUEST = 'FETCH_REFERENCES_REQUEST';
export const FETCH_REFERENCES_SUCCESS = 'FETCH_REFERENCES_SUCCESS';
export const FETCH_REFERENCES_FAILURE = 'FETCH_REFERENCES_FAILURE';

export const ADD_REFERENCE_REQUEST = 'ADD_REFERENCE_REQUEST';
export const ADD_REFERENCE_SUCCESS = 'ADD_REFERENCE_SUCCESS';
export const ADD_REFERENCE_FAILURE = 'ADD_REFERENCE_FAILURE';

export const DELETE_REFERENCE_REQUEST = 'DELETE_REFERENCE_REQUEST';
export const DELETE_REFERENCE_SUCCESS = 'DELETE_REFERENCE_SUCCESS';
export const DELETE_REFERENCE_FAILURE = 'DELETE_REFERENCE_FAILURE';


export const SET_KEYWORDS = 'SET_KEYWORDS';
export const SET_DOCUMENTS = 'SET_DOCUMENTS';
export const SET_DATABASE_SELECTION = 'SET_DATABASE_SELECTION';
export const SET_JSON = 'SET_JSON';
export const SET_SEARCH_START_TIME = 'SET_SEARCH_START_TIME';
export const SET_DB_ACCOR = 'SET_DB_ACCOR';
export const SET_KEYWORD_ACCOR = 'SET_KEYWORD_ACCOR';
export const SET_DETAIL_ACCOR = 'SET_DETAIL_ACCOR';
export const SET_DETAIL_ACCOR_DISABLED = 'SET_DETAIL_ACCOR_DISABLED';
export const SET_DOC_ACCOR = 'SET_DOC_ACCOR';
export const SET_PLOTLY_ABSTRACT = 'SET_PLOTLY_ABSTRACT';
export const SET_PLOTLY_TITLE = 'SET_PLOTLY_TITLE';
export const SET_PLOTLY_URL = 'SET_PLOTLY_URL';
export const SET_NAV_BAR = 'SET_NAV_BAR';
export const SET_PLOTLY_DATABASE = 'SET_PLOTLY_DATABASE';
export const SET_SEARCH_BUTTON_STATUS = 'SET_SEARCH_BUTTON_STATUS';
export const SET_SPINNER_STATUS = 'SET_SPINNER_STATUS';
export const SET_BAD_KEYWORDS = 'SET_BAD_KEYWORDS';
export const SET_PREVIOUS_KEYWORDS = 'SET_PREVIOUS_KEYWORDS';
export const SET_DATABASE_DID_CHANGE = 'SET_DATABASE_DID_CHANGE';
export const SET_READY_STATUS = 'SET_READY_STATUS';
export const SET_SEARCH_MESSAGE = 'SET_SEARCH_MESSAGE';
export const SET_ARTICLES = 'SET_ARTICLES';
export const SET_BOOKMARK = 'SET_BOOKMARK';
export const SET_ARTICLE_ACCOR_TAB = 'SET_ARTICLE_ACCOR_TAB';
export const SET_TASK_ID = 'SET_TASK_ID';
export const SET_RANKED_VIEW_TAB = 'SET_RANKED_VIEW_TAB';
export const SET_RANKED_LIST = 'SET_RANKED_LIST';
export const SET_DISABLE_RANKED_VIEW_TAB = 'SET_DISABLE_RANKED_VIEW_TAB';
export const SET_SOURCE_ARTICLE = 'SET_SOURCE_ARTICLE';
export const SET_HISTORY_LIST = 'SET_HISTORY_LIST';
export const SET_RANKED_MINI_LIST = 'SET_RANKED_MINI_LIST';
export const SET_SEARCH_SPACE = 'SET_SEARCH_SPACE';
export const SET_ARTICLE_FLAG = 'SET_ARTICLE_FLAG';
export const SET_PINNED_ARTICLES = 'SET_PINNED_ARTICLES';
export const SET_SAVED_DOCUMENTS = 'SET_SAVED_DOCUMENTS';
export const SET_TEMP_REMOVED_DOCUMENTS = 'SET_TEMP_REMOVED_DOCUMENTS';
export const SET_FILTER_STATUS = 'SET_FILTER_STATUS';
export const SET_SAVE_BUTTON_STATUS = 'SET_SAVE_BUTTON_STATUS';
export const SET_USER_HISTORY_COUNT = 'SET_USER_HISTORY_COUNT';
export const SET_SEARCH_TITLE = 'SET_SEARCH_TITLE';
export const SET_SEARCH_DESCRIPTION = 'SET_SEARCH_DESCRIPTION';
export const SET_SPACES_LIST = 'SET_SPACES_LIST';
export const SET_SEARCH_SPACE_TAB_STATUS = 'SET_SEARCH_SPACE_TAB_STATUS';
export const SET_SEARCH_SPACE_DESCRIPTION = 'SET_SEARCH_SPACE_DESCRIPTION';
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const CLEAR_ALERTS = 'CLEAR_ALERTS';
export const SET_PLOTLY_CLICK_DATA = 'SET_PLOTLY_CLICK_DATA';

export function setKeywords(keywords) {
    return {type: SET_KEYWORDS, keywords}
}

export function setDocuments(documents) {
    return {type: SET_DOCUMENTS, documents}
}

export function setDatabaseSelection(database) {
    return {type: SET_DATABASE_SELECTION, database}
}

export function setJSON(json) {
    return {type: SET_JSON, json}
}

export function setSearchStartTime(startTime) {
    return {type: SET_SEARCH_START_TIME, startTime}
}

export function setDbAccordionStatus(status) {
    return {type: SET_DB_ACCOR, status}
}

export function setKeywordAccordionStatus(status) {
    return {type: SET_KEYWORD_ACCOR, status}
}

export function setDetailAccordionStatus(status) {
    return {type: SET_DETAIL_ACCOR, status}
}

export function setDetailAccordionDisabled(status) {
    return {type: SET_DETAIL_ACCOR_DISABLED, status}
}

export function setDocAccordionStatus(status) {
    return {type: SET_DOC_ACCOR, status}
}

export function setPlotlyAbstractVar(abstract) {
    return {type: SET_PLOTLY_ABSTRACT, abstract}
}

export function setPlotlyTitleVar(title) {
    return {type: SET_PLOTLY_TITLE, title}
}

export function setPlotlyUrlVar(url) {
    return {type: SET_PLOTLY_URL, url}
}

export function setPlotlyDbVar(database) {
    return {type: SET_PLOTLY_DATABASE, database}
}

export function setNavBar(status) {
    return {type: SET_NAV_BAR, status}
}

export function setSearchButtonDisabled(status) {
    return {type: SET_SEARCH_BUTTON_STATUS, status}
}

export function setSpinnerStatus(status) {
    return {type: SET_SPINNER_STATUS, status}
}

export function setBadKeywordList(badKeywords) {
    return {type: SET_BAD_KEYWORDS, badKeywords}
}

export function setPreviousKeywordList(previousKeywords) {
    return {type: SET_PREVIOUS_KEYWORDS, previousKeywords}
}

export function setDatabaseDidChange(change) {
    return {type: SET_DATABASE_DID_CHANGE, change}
}

export function setSearchStatus(status) {
    return {type: SET_READY_STATUS, status}
}

export function setSearchMessage(message) {
    return {type: SET_SEARCH_MESSAGE, message}
}

export function setArticles(articles) {
    return {type: SET_ARTICLES, articles}
}

export function setBookmark(status) {
    return {type: SET_BOOKMARK, status}
}

export function setArticleAccordTab(tab) {
    return {type: SET_ARTICLE_ACCOR_TAB, tab}
}

export function setTaskId(id) {
    return {type: SET_TASK_ID, id}
}

export function setRankedTab(tab) {
    return {type: SET_RANKED_VIEW_TAB, tab}
}

export function setRankedList(rankedList) {
    return {type: SET_RANKED_LIST, rankedList}
}

export function setRankedTabDisable(disable) {
    return {type: SET_DISABLE_RANKED_VIEW_TAB, disable}
}

export function setRankedArticleSource(source) {
    return {type: SET_SOURCE_ARTICLE, source}
}

export function setHistoryList(historyList) {
    return {type: SET_HISTORY_LIST, historyList}
}

export function setRankedMiniList(rankedMiniList) {
    return {type: SET_RANKED_MINI_LIST, rankedMiniList}
}

export function setSearchSpace(searchSpace) {
    return {type: SET_SEARCH_SPACE, searchSpace}
}

export function setArticleFlag(articleFlag) {
    return {type: SET_ARTICLE_FLAG, articleFlag}
}

export function setPinnedArticles(pinnedArticles) {
    return {type: SET_PINNED_ARTICLES, pinnedArticles}
}

export function setSavedDocuments(savedDocuments){
    return {type: SET_SAVED_DOCUMENTS, savedDocuments}
}

export function setTempRemoveDocuments(removedDocuments) {
    return {type: SET_TEMP_REMOVED_DOCUMENTS, removedDocuments}
}

export function setFilterStatus(filter){
    return {type: SET_FILTER_STATUS, filter}
}

export function setSaveButtonStatus(button){
    return {type: SET_SAVE_BUTTON_STATUS, button}
}

export function setHistoryCount(historyCount){
    return {type: SET_USER_HISTORY_COUNT, historyCount}
}

export function setSearchTitle(title){
    return {type: SET_SEARCH_TITLE, title}
}

export function setSearchDescription(description){
    return {type: SET_SEARCH_DESCRIPTION, description}
}

export function setSpacesList(spaceList){
    return {type: SET_SPACES_LIST, spaceList}
}

export function setSearchSpaceTabStatus(searchSpaceTabStatus){
    return {type: SET_SEARCH_SPACE_TAB_STATUS, searchSpaceTabStatus}
}

export function setSearchSpaceDescription(searchSpaceDescription){
    return {type: SET_SEARCH_SPACE_DESCRIPTION, searchSpaceDescription}
}

export function setAlert(alert)  {
    return {type: SET_ALERT, alert}
}

export function removeAlert(id) {
    return {type: REMOVE_ALERT, id}
}

export function clearAlerts() {
    return {type: CLEAR_ALERTS}
}

export function setPlotlyClickData(data){
    return {type: SET_PLOTLY_CLICK_DATA, data}
}


export function fetchReferences(searchSpace) {
    return async function (dispatch) {
        dispatch({ type: FETCH_REFERENCES_REQUEST });

        try {
            const data = await fetchGetSpaceReferences(searchSpace);
            dispatch({ type: FETCH_REFERENCES_SUCCESS, payload: data });
        } catch (error) {
            dispatch({ type: FETCH_REFERENCES_FAILURE, error: error.message });
        }
    };
}

export function addReference(formData, searchSpace, selectedDirectoryId) {
    return async function (dispatch) {
        dispatch({ type: ADD_REFERENCE_REQUEST });

        try {
            const payload = {
                ...formData,
                space_name: searchSpace,
                notes: formData.notes || '',
                date_published: formData.date_published || null,
                date_accessed: formData.date_accessed || null,
                authors: Array.isArray(formData.authors)
                    ? formData.authors
                    : formData.authors ? [formData.authors] : []
            };

            await fetchAddReference(selectedDirectoryId, payload);
            dispatch({ type: ADD_REFERENCE_SUCCESS });

        } catch (error) {
            dispatch({ type: ADD_REFERENCE_FAILURE, error: error.message });
        }
    };
}

export const deleteReference = (referenceId, searchSpace) => async (dispatch) => {
    try {
      await fetchDeleteReference(referenceId);
      dispatch(fetchReferences(searchSpace)); // Refresh references after deletion
    } catch (err) {
      console.error("Redux deleteReference error:", err);
    }
  };
